import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { fetchClerkAuth } from "./__root";

export const Route = createFileRoute("/_auth")({
  beforeLoad: async ({ location }) => {
    // Don't redirect if we came from an auth failure
    const searchParams = new URLSearchParams(location.search);
    const fromAuthFailure = "auth-failure" === searchParams.get("from");

    if (fromAuthFailure) {
      return;
    }

    if ((await fetchClerkAuth()).userId) {
      throw redirect({ to: "/settings" });
    }
  },
  component: AuthLayout,
});

function AuthLayout() {
  return (
    <div className="mx-auto flex h-screen items-center justify-center">
      <Outlet />
    </div>
  );
}
